import { render } from "./index.vue?vue&type=template&id=ab270b00"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ab270b00&lang=scss"

import exportComponent from "/Users/aminmx/Desktop/workspace/law360/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__